/* eslint-disable max-len */
import { getFeatureToggles } from "@teamprevent/common/getFeatureToggles";
import * as FeatureToggleNames from "@teamprevent/common/featureToggleNames";

import { MedicalTypeIds } from "../../models";
import * as questionIds from "../../questions/questionIds";

const enableNewNightWorkerQuestions = getFeatureToggles()[FeatureToggleNames.EnableNewNightWorkerQuestions];

export const medicalQuestions = [
    {
        id: questionIds.HideEmployeeQuestionsAndRecordMedicalSeparately,
        questionText: "Hide employee questions and record medical history separately"
    },
    {
        id: questionIds.MedicalHistoryDetails,
        questionText: "Medical history",
    },
    {
        id: questionIds.ConsiderYourselfGoodHealth,
        questionText: "Do you consider yourself to be in good health?",
    },
    {
        id: questionIds.ConsiderYourselfGoodHealthFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.ReceivingAnyFormMedicalTreatment,
        questionText: "Are you receiving any form of medical treatment?",
    },
    {
        id: questionIds.ReceivingAnyFormMedicalTreatmentFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.TakingRegularMedication,
        questionText: "Are you taking any regular medication?",
    },
    {
        id: questionIds.TakingRegularMedicationFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.SufferFromDisabilityImpairment,
        questionText: "Do you suffer from any form of disability / impairment?",
    },
    {
        id: questionIds.SufferFromDisabilityImpairmentFurtherDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.ConditionAttentionOccupationalHealthTeam,
        questionText: "Is there any other condition that you may wish to bring to the attention of the Occupational Health Team?",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.WorkingThermalEnvironment,
            ...(enableNewNightWorkerQuestions ? [] : [MedicalTypeIds.NightWorker]),
            MedicalTypeIds.LoneWorker,
            MedicalTypeIds.FoodHandlerQuestionsOnly,
            MedicalTypeIds.DSE,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.ManualHandlingMSKQuestionnaire,
            MedicalTypeIds.ManualHandlingMSKFaceToFaceAppointment,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration
        ]
    },
    {
        id: questionIds.ConditionAttentionOccupationalHealthTeamFurtherDetails,
        questionText: "Please provide details",
        medicalTypes: [
            MedicalTypeIds.SafetyCriticalWorker,
            MedicalTypeIds.GroupOneDriving,
            MedicalTypeIds.GroupTwoDriving,
            MedicalTypeIds.WorkAtHeight,
            MedicalTypeIds.WorkingConfinedSpaces,
            MedicalTypeIds.WearingRPE,
            MedicalTypeIds.WearingBreathingApparatus,
            MedicalTypeIds.WorkingThermalEnvironment,
            ...(enableNewNightWorkerQuestions ? [] : [MedicalTypeIds.NightWorker]),
            MedicalTypeIds.LoneWorker,
            MedicalTypeIds.FoodHandlerQuestionsOnly,
            MedicalTypeIds.DSE,
            MedicalTypeIds.Offshore,
            MedicalTypeIds.Airside,
            MedicalTypeIds.OtherFitnessToWork,
            MedicalTypeIds.ManualHandlingMSKQuestionnaire,
            MedicalTypeIds.ManualHandlingMSKFaceToFaceAppointment,
            MedicalTypeIds.AmzPitPupMedical,
            MedicalTypeIds.AmzPitPupHealthDeclaration
        ]
    },
];
